import styled from 'styled-components'

type Props = {
	size: number
}

export const Container = styled.div<Props>`
	position: relative;
	text-align: center;

	border-radius: 50%;

	height: ${({ size }) => size}px;
	width: ${({ size }) => size}px;
`
